import { CustomLoaderView } from "./custom-loader-view";

const CustomLoader = ({ page }: { page?: boolean }) => {
  return <CustomLoaderView page={page} />;
};

export { CustomLoader };
